import { LoaderTypeEnum } from 'libs/shared/utils/loader/src/lib/+state/loader.models'

/**
 * Interface for the 'Taxes' data
 */
export enum TaxesMethodEnum {
  add = 'add',
  include = 'include',
}

export interface TaxesEntity {
  uuid: string
  auction: string
  label: string
  tax_rate: number
  method: TaxesMethodEnum
  auto_apply_tax_to_items: boolean
}

export enum TaxesActionTypeEnum {
  create = 'create',
  delete = 'delete',
  update = 'update',
}

export const TAXES_LOADER = {
  applyTaxToAllItems: {
    id: 'applyTaxToAllItems',
  },
  deleteTax: {
    id: 'applyTaxToAllItems',
  },
}
